import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../../../core/services';
import { ApiResponse } from '../../../core/models';
import { BusinessActivityDTO } from '../../models/shared.model';
import { BusinessActivityRepository } from '../contracts/business-activity.repository';

@Injectable({
  providedIn: 'root',
})
export class BusinessActivityHttpRepository
  extends BaseApiService
  implements BusinessActivityRepository
{
  /**
   * GET `/api/v1/BusinessActivity/list` (respuesta `Response<List<BusinessActivityDTO>>`).
   */
  listBusinessActivities(): Observable<HttpResponse<ApiResponse<BusinessActivityDTO[]>>> {
    return this.http.get<ApiResponse<BusinessActivityDTO[]>>(
      `${this.baseUrl}/BusinessActivity/list`,
      { observe: 'response' }
    );
  }
}
